import React from 'react';

type DotBtnItemProps = {
    name?: string
    css?: string
    onClick: any
}

const DotBtnItem = ({name, css, onClick}: DotBtnItemProps) => 
    <span className={'btn-dots__menu-link ' + ( css || '')} onClick={() => onClick()}>{name}</span>;

export default DotBtnItem;